//不显示的

// 并列在工作台

const imageView = () => import("@/components/index/imageView");
const WXbind = () => import("@/components/login/WXbind");
const theme = () => import("@/components/index/theme");

const login = () => import("@/components/login/login");
const loginnew = () => import("@/components/login/loginnew");
const register = () => import("@/components/login/register");
const WXlogin = () => import("@/components/login/WXlogin");
const rulesShow = () => import("@/components/login/rulesShow");

const operationManualView = () =>
  import("@/components/index/operationManualView"); //done

//规则
const rule = () => import("@/components/agreement/rule"); //done
//规则详情
const ruleDdetails = () => import("@/components/agreement/rule-details"); //done
//规则列表
const ruleList = () => import("@/components/agreement/rule-list"); //done
//意见
const opinion = () => import("@/components/agreement/opinion"); //done

const testing = () => import("@/components/testSystem/userModules/testing");
const testInfo = () => import("@/components/testSystem/userModules/testInfo");
const testPreview = () =>
  import("@/components/testSystem/userModules/testPreview");
const find = () => import("@/components/login/find");
export default [{
    path: "/find",
    name: "find",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: find,
  },
  {
    path: "/testPreview",
    name: "testPreview",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: testPreview,
  },
  {
    path: "/testInfo",
    name: "testInfo",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: testInfo,
  },
  //进行考试
  {
    path: "/testing",
    name: "testing",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: testing,
  },
  {
    path: "/operationManualView",
    name: "operationManualView",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: operationManualView,
  },
  {
    path: "/theme",
    component: theme,
    meta: {
      belong: ["none"],
      text: "换肤",
    },
  },
  {
    path: "/WXbind",
    name: "WXbind",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: WXbind,
  },
  {
    path: "/login",
    name: "loginnew",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: loginnew,
  },
  {
    path: "/loginnew",
    name: "login",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: login,
  },
  {
    path: "/register",
    name: "register",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: register,
  },
  {
    path: "/rulesShow",
    name: "rulesShow",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: rulesShow,
  },
  {
    path: "/WXlogin",
    name: "WXlogin",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: WXlogin,
  },
  {
    path: "/imageView",
    name: "imageView",
    meta: {
      belong: ["none"],
      noStore: true,
    },
    component: imageView,
  },
  {
    path: "/ruleList/:id",
    name: "rule",
    component: rule,
    meta: {
      belong: ["none"],
      rule: true,
      noStore: true,
    },
    children: [{
        path: "/ruleDdetails",
        name: "ruleDdetails",
        component: ruleDdetails,
        meta: {
          belong: ["none"],
          rule: true,
          noStore: true,
        },
      },
      {
        path: "/ruleList/:id",
        name: "ruleList",
        component: ruleList,
        meta: {
          belong: ["none"],
          rule: true,
          noStore: true,
        },
      },
      {
        path: "/opinion",
        name: "opinion",
        component: opinion,
        meta: {
          belong: ["none"],
          rule: true,
          noStore: true,
        },
      },
    ],
  },
];
